import { render, staticRenderFns } from "./OrderKanbanHeader.vue?vue&type=template&id=732f9d24&scoped=true&"
import script from "./OrderKanbanHeader.vue?vue&type=script&lang=js&"
export * from "./OrderKanbanHeader.vue?vue&type=script&lang=js&"
import style0 from "~/components/orderKanban/OrderKanbanHeader.scss?vue&type=style&index=0&id=732f9d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f9d24",
  null
  
)

export default component.exports